const Home = () => import(/* webpackChunkName: 'property' */ './home');
const Notice = () => import(/* webpackChunkName: 'property' */ './notice');
const Adduser = () => import(/* webpackChunkName: 'property' */ './adduser');
const updateUser = () => import(/* webpackChunkName: 'property' */ './updateUser');
const userDetail = () => import(/* webpackChunkName: 'property' */ './userdetail');
const Comservice = () => import(/* webpackChunkName: 'property' */ './comservice');
const Information = () => import(/* webpackChunkName: 'property' */ './information');
const Informationadd = () => import(/* webpackChunkName: 'property' */ './informationadd');
const Updateinformation = () => import(/* webpackChunkName: 'property' */ './updateinformation');
const Seeinformation = () => import(/* webpackChunkName: 'property' */ './seeinformation');
const routes = [
  { path: '/property', component: Home },
  { path: '/property/notice', component: Notice },
  { path: '/property/adduser', component: Adduser },
  { path: '/property/updateuser', component: updateUser },
  { path: '/property/userdetail', component: userDetail },
  { path: '/property/comservice', component: Comservice },
  { path: '/property/information', component: Information },
  { path: '/property/informationadd', component: Informationadd },
  { path: '/property/updateinformation', component: Updateinformation },
  { path: '/property/seeinformation', component: Seeinformation }
];

export default routes;
